import { Routes } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from './core/services/auth.service';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { NotFoundComponent } from './pages/other-pages/not-found/not-found.component';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  /* =======================
   * Direct Register Route
   * ======================= */
  {
    path: 'register',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/register/register.component').then(m => m.RegisterComponent),
    title: 'W90-TVK MDU'
  },

  /* =======================
   * Auth Routes (Login, etc.)
   * ======================= */
  {
    path: 'auth',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./features/auth/auth.routes').then(c => c.AUTH_ROUTES),
  },
  {
    path: 'login',
    redirectTo: 'auth/login',
    pathMatch: 'full'
  },

  /* =======================
   * Admin CMS
   * ======================= */
  {
    path: 'admin/login',
    redirectTo: 'auth/login',
    pathMatch: 'full'
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin.routes')
        .then(c => c.ADMIN_ROUTES),
  },

  /* =======================
   * Default: Role-based or Login Redirect
   * ======================= */
  {
    path: '',
    pathMatch: 'full',
    redirectTo: () => {
      const authService = inject(AuthService);
      if (authService.isAuthenticated()) {
        return authService.isAdmin() ? '/admin' : '/register';
      }
      return '/auth/login';
    }
  },

  /* =======================
   * 404
   * ======================= */
  {
    path: '**',
    component: NotFoundComponent,
  },
];



